import { ArrayField, FunctionField, TextField } from 'react-admin';
import { PROFILE_STATUS_VALUE_MAP } from '@/pages/Candidate/constants';
import { path } from '@/pages/Candidate/view/tables/StatusHistoryTable/constants';
import { StatusHistoryTableProps } from '@/pages/Candidate/view/tables/StatusHistoryTable/types';
import { SecondaryDatagridStyled } from '@/styles/overrides';
import { FCRAWorker } from '@/types/turn-api';
import { getShortDateString } from '@/utils';

const StatusHistoryTable = ({ source }: StatusHistoryTableProps) => {
  return (
    <ArrayField source={source}>
      <SecondaryDatagridStyled bulkActionButtons={false} rowClick={false}>
        <FunctionField
          label="Status"
          sortable={false}
          render={(row: FCRAWorker.StatusHistory) =>
            PROFILE_STATUS_VALUE_MAP[row?.status?.toLowerCase()]?.toUpperCase()
          }
        />
        <FunctionField
          label="Previous Status"
          sortable={false}
          render={(row: FCRAWorker.StatusHistory) =>
            PROFILE_STATUS_VALUE_MAP[row?.originalStatus?.toLowerCase()]?.toUpperCase()
          }
        />
        <FunctionField
          label="Modified At"
          sortable={false}
          render={(row: FCRAWorker.StatusHistory) => getShortDateString(row.modifiedAt)}
        />
        <TextField source={path('author')} label="Author" sortable={false} />
        <TextField source={path('source')} label="Source" sortable={false} />
      </SecondaryDatagridStyled>
    </ArrayField>
  );
};

export default StatusHistoryTable;
